import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Nav as BootstrapNav } from 'reactstrap';

const Nav = ({ accent, className, ...otherProps }) => {
    return (
        <BootstrapNav
            className={
                classNames(className, 'nav', { 'nav-accent': accent })
            }
            { ...otherProps }
        />
    );
};
Nav.propTypes = {
    ...BootstrapNav.propTypes,
    accent: PropTypes.bool,
};
Nav.defaultProps = {
    accent: false
};

export { Nav };
